import React, { Component } from 'react';
import Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);
import { getCountryDataMap } from '../../../api'

class MapChart extends Component {
	 
	constructor(props) {
		super(props);
		
		this.handleSelect = this.handleSelect.bind(this)
		this.state ={
			select:"",
			chartConfig: {
				chart: {
					map: require('../../../model/map.europe.geo.json'),
					spacingBottom: 20,
					height: 800,
					width: 1024,
					backgroundColor: '#F0F0F0'
				},
				countrySelected: '',

				title: {
					text: this.props.title
				},

				tooltip: {
					enabled: false
				},

				credits: {
					enabled: false
				},
				
				exporting: {
					enabled: false,
					y:-10,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
					chartOptions:
					{
						credits: {
							enabled: true
						}
					}
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 4
					}
				},
				legend: {
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'top',
					y: 45,
				},
				colorAxis: {
					type: 'linear',
					minColor: '#dcecec',
                    maxColor: '#4a8e91',
					stops: [
                        [0, '#DAEBEC'],
                        // [0.25, '#badddd'],
                        [0.5, '#B4D6D7'],
                        // [0.75, '#78b4b6'],
                        [1,'#4a8e91'],
                    ],
					tickPixelInterval: 100
				},
				plotOptions: {
					map: {
                        nullColor: '#F0F0F0',
						// MDV-505 - This hides all countries that don't have value
						// allAreas: false
                    },
					series: {
						allowPointSelect: true,
						cursor: 'pointer',
						borderColor: '#c4c4c4',
						borderWidth: 2,
						states:{
							hover: {
								enabled: true,
								borderColor: '#57575A',
								//color:'#000000'
							},
							select: {
								color: '#f6a400'
							}
						},
						point: {
							events: {
								click: this.countrySelect = (e) =>  {
									this.handleSelect(e.point.name)
									if (this.state.countrySelected != e.point.name) {
										this.setState({
											countrySelected: e.point.name
										})
									} else {
										e.preventDefault()
									}
								}
							}
						}
					}
				},			
				series: []
			}
		}	
	}



	getLoadData = (select, datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4) => {
		let series = [];
		getCountryDataMap(datasetIndicator1, datasetIndicator2, datasetIndicator3, datasetIndicator4)
			.then((response)=> response)
			.then((res) => 
		{
			let	seriesObject = { name: '', data:[] };
			let patternObject = { name: '', data: [], 					
				dataLabels: {
					enabled: true,
					color: '#000',
					style: {
						textShadow: false, 
						textOutline: "#c7e2e3",
						fontFamily: 'OpenSans-Bold',
						fontSize:'14px'
					},
					formatter: function () {
						if (this.point.value) {
							if(this.point["hc-key"] === "gr"){
								return "EL";
							}else if(this.point["hc-key"] === "gb"){
								return "UK";
							}else if(this.point["hc-key"] === "hr"){
								this.point.properties['hc-middle-x'] = 0.50
								this.point.properties['hc-middle-y'] = 0.20
								return "HR";
							}else if(this.point["hc-key"] === "nl"){
								if(window.innerWidth < 425){
									this.point.properties['hc-middle-x'] = 0.70
									this.point.properties['hc-middle-y'] = 0.20
								}else{
									this.point.properties['hc-middle-x'] = 0.60
									this.point.properties['hc-middle-y'] = 0.50
								}
								return "NL";
							}else if(this.point["hc-key"] === "mt"){
								this.point.properties['hc-middle-y'] = -0.80;
								return "MT";
							}else{
								return this.point["hc-key"].toUpperCase();
							}
						}
					}
				}
			};
			let data = [];
			res.resultset.forEach((element)=>{						
				let countryCode = element.countryCode.toLowerCase();
				if (countryCode != 'eu27_2020' && countryCode != 'eu28')
				{
					if(countryCode === "el"){
						countryCode = "gr";
					}else if(countryCode === "uk"){
						countryCode = "gb";
					}
					data.push({ countryCode: countryCode, value: element.data[select] });
				}
			})
			
			data.forEach((element) => {
				if(element.value != undefined){
					seriesObject.data.push([element.countryCode, element.value]);

					if (element.countryCode == "no" || element.countryCode == "is" || element.countryCode == "ch")
					{
						patternObject.data.push({'hc-key': element.countryCode, value: element.value, color: {
							pattern: {
							path: {
								d: 'M 0 10 L 10 0 M -10 10 L 10 -10 M 8 12 L 12 8',
								strokeWidth: 2
							},
							color: '#fff',
							width: 10,
							height: 10,
							opacity: 0.6
							}
						}, borderColor:'white'});
					}
					else
					{
						patternObject.data.push({'hc-key': element.countryCode, value: element.value, borderColor: 'white'});
					}
				}
			})
			
			series.push(seriesObject);
			series.push(patternObject);

			this.setState({chartConfig: {...this.state.chartConfig, series }})
		});		
	}

	componentDidMount() {
		this.getLoadData(this.props.select, this.props.datasetIndicator1, this.props.datasetIndicator2, this.props.datasetIndicator3, this.props.datasetIndicator4);
	}

	handleSelect = (pCountryName) =>{
		 const {handleSearch}= this.props
		handleSearch(pCountryName)
	}

	componentDidUpdate(prevProps, prevState){
		if (prevProps.select != this.props.select || prevProps.datasetIndicator1 != this.props.datasetIndicator1
			|| prevProps.datasetIndicator2 != this.props.datasetIndicator2 || prevProps.datasetIndicator3 != this.props.datasetIndicator3
			|| prevProps.datasetIndicator4 != this.props.datasetIndicator4 || prevProps.unselect != this.props.unselect){
			this.getLoadData(this.props.select, this.props.datasetIndicator1, this.props.datasetIndicator2, this.props.datasetIndicator3, this.props.datasetIndicator4);
			if (prevProps.unselect != this.props.unselect)
			{
				this.setState( { countrySelected: '' } )
			}
		}
		if(prevProps.title != this.props.title){
			this.setState({chartConfig: {...this.state.chartConfig, title:{...this.state.chartConfig.title, text: this.props.title}}})
		}
	}

	render()
	{
		return(
			<div>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.state.chartConfig}
					constructorType='mapChart'
				/>
			</div>
		);
	}
}

export default MapChart;
